var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Effect, Actions } from '@ngrx/effects';
import * as potentialAction from '../actions/potential.action';
import { switchMap, mergeMap, withLatestFrom, filter } from 'rxjs/operators';
import { of } from 'rxjs/observable/of';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs/Observable';
import { isNullOrUndefined } from 'util';
import { PotentialService } from '../../potential.service';
var PotentialEffects = /** @class */ (function () {
    function PotentialEffects(actions, potentialService, store) {
        var _this = this;
        this.actions = actions;
        this.potentialService = potentialService;
        this.store = store;
        this.getAllPotentials = this.actions.ofType(potentialAction.GET_ALL_POTENTIALS)
            .pipe(switchMap(function () {
            return _this.potentialService.getAllPotentials()
                .map(function (res) { return new potentialAction.GetAllPotentialsSuccess(res); })
                .catch(function (error) { return of(new potentialAction.GetAllPotentialsError(error)); });
        }));
        this.getPotential = this.actions.ofType(potentialAction.GET_POTENTIAL)
            .pipe(withLatestFrom(
        // select users.
        this.store.select(function (state) { return state.potentialsFeature.potentials.users; }), function (action, users) {
            // if no users present, proceed for API.
            if (isNullOrUndefined(users)) {
                return action;
            }
            else {
                // users exists in store.
                var potential = users.filter(function (p) { return p.id === action.payload; })[0];
                if (!!potential) {
                    // if required user is present in store, then return;
                    return undefined;
                }
                else {
                    // if required user not present in store, then proceed for API.
                    return action;
                }
            }
        }), filter(function (action) { return !!action; }), mergeMap(function (action) {
            return _this.potentialService.getPotential(action.payload)
                .map(function (res) { return new potentialAction.GetPotentialSuccess(res); })
                .catch(function (error) { return of(new potentialAction.GetPotentialError(error)); });
        }));
        this.approvePotential = this.actions.ofType(potentialAction.APPROVE_POTENTIAL)
            .map(function (action) { return action.payload; })
            .pipe(switchMap(function (payload) {
            return _this.potentialService.approvePotential(payload)
                .map(function (res) { return new potentialAction.UpdatePotentialSuccess(res); })
                .catch(function (error) { return of(new potentialAction.UpdatePotentialError(error)); });
        }));
        this.rejectPotential = this.actions.ofType(potentialAction.REJECT_POTENTIAL)
            .map(function (action) { return action.payload; })
            .pipe(switchMap(function (payload) {
            return _this.potentialService.rejectPotential(payload)
                .map(function (res) { return new potentialAction.UpdatePotentialSuccess(res); })
                .catch(function (error) { return of(new potentialAction.UpdatePotentialError(error)); });
        }));
    }
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], PotentialEffects.prototype, "getAllPotentials", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], PotentialEffects.prototype, "getPotential", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], PotentialEffects.prototype, "approvePotential", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], PotentialEffects.prototype, "rejectPotential", void 0);
    return PotentialEffects;
}());
export { PotentialEffects };



// WEBPACK FOOTER //
// /Users/Chetan/Downloads/angular5_admin-master/src/app/potentials/store/effects/potential.effects.ts.pre-build-optimizer.js